import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './dashboard/login/login.component';
import { AppselectorComponent } from './dashboard/appselector/appselector.component';
import { RegisterComponent } from './dashboard/register/register.component';
import { SetpasswordComponent } from './dashboard/home/setpassword/setpassword.component';
import { DigitalAssistantComponent } from './dashboard/digital-assistant/digital-assistant.component';
import { SignupComponent } from './dashboard/signup/signup.component';
import { SelfOnboardPlansComponent } from './dashboard/self-onboard-plans/self-onboard-plans.component';
import { SelfSignupComponent } from './dashboard/self-signup/self-signup.component';
import { RedirectionComponent } from './dashboard/redirection/redirection.component';
const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    data: { title: 'Login' },
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: { title: 'Register' },
  },
  { path: 'apps', component: AppselectorComponent, data: { title: 'Apps' } },
  {
    path: 'setpassword',
    component: SetpasswordComponent,
    data: { title: 'Set Password' },
  },
  {
    path: 'aiagent',
    component: DigitalAssistantComponent,
    data: { title: 'AI agent' },
  },
  {
    path: 'verify/account',
    component: SignupComponent,
    data: { title: 'Verify' },
  },
  {
    path: 'signup',
    component: SelfSignupComponent,
    data: { title: 'Sign Up' },
  },
  {
    path: 'plans',
    component: SelfOnboardPlansComponent,
    data: { title: 'Plans' },
  },
  {
    path: 'redirection',
    component: RedirectionComponent,
    data: { title: 'Redirection' },
  },
  { path: '**', redirectTo: '/login', pathMatch: 'full' },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' }),
  ],
  exports: [RouterModule],
  declarations: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppRoutingModule {
  static forRoot(arg0: undefined[]): any {
    throw new Error('Method not implemented.');
  }
}
